import React from "react";
import { withTranslation } from "react-i18next";
import { FlexRow, ButtonData } from "./Tabs.styled";

const Tabs = (props) => {
  const { t, activeTab, toggleTab, data } = props;

  return (
    <FlexRow>
      {[12, 13, 14, 15].includes(data.status) && (
        <div>
          <ButtonData
            marginRight="10px"
            color={activeTab === "followUp" ? "#008395" : "#cccccc"}
            onClick={() => toggleTab("followUp")}
          >
            {t("SITE_FOLLOWUP_TITLE")}
          </ButtonData>
        </div>
      )}
      <div>
        <ButtonData
          marginRight="10px"
          color={activeTab === "finacialInformation" ? "#008395" : "#cccccc"}
          onClick={() => toggleTab("finacialInformation")}
        >
          {t("SITE_FINANCIAL_INFORMATION_TITLE")}
        </ButtonData>
      </div>
    </FlexRow>
  );
};

export default withTranslation()(Tabs);
